import React from 'react';
import { observer } from 'mobx-react';
import FeaturedBlogPostCard from './FeaturedBlogPostCard';
import { Carousel } from '@common/bw-ui/ui/carousel';
import { useFeaturedBlogsQuery } from '../hooks/useBlogs';

// observer: useAuth reads MobX state, so a change of user re-runs the query.
// Renders an empty carousel while loading or on error.
const FeaturedBlogPostCarousel: React.FC = observer(() => {
  const { data: featuredBlogs } = useFeaturedBlogsQuery();

  return (
    <Carousel
      items={featuredBlogs ?? []}
      ariaLabel="Featured Blogs"
      renderItem={(blog) => <FeaturedBlogPostCard featuredBlogPost={blog} />}
    />
  );
});

export default FeaturedBlogPostCarousel;
